module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-4x3-mobile@1x.5a7e3466.png";